import React, { useEffect, useRef, useState } from "react";

// Material UI
import { styled } from "@mui/system";
import { Button, Menu, MenuItem, Avatar, Box, Typography } from "@mui/material";
import { AccessTime, MailOutline, Language } from "@mui/icons-material";

// languages data
import languages from "../Common/data/languages";
import i18n from "../i18n";

// Images
import useStyles, { Colortheme } from "../pages/comman";

// MUI Style
const TopTagBar = styled("div")({
  backgroundColor: "#343a40",
  color: "white",
  padding: "30px 0",
  fontSize: "13px",
});

const IconText = styled("div")({
  display: "flex",
  alignItems: "center",
});

const LanguageDropdown = styled(Button)({
  display: "flex",
  alignItems: "center",
  color: "white",
  border: "none",
  padding: "10px",
  "&:hover": {
    backgroundColor: "transparent",
  },
});

const StyledMenuItem = styled(MenuItem)`
  && {
    display: flex;
    align-items: center;
    padding: 6px 20px;
    color: white;
    &:hover {
      background-color: "#f3f6f9";
    }
    img {
      margin-right: 8px;
      border-radius: 4px;
    }
  }
`;

const EmailWebsiteDiv = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0.75rem",
  fontSize: "13px",
  color: "white",
});

const Topbar = () => {
  const currentTime: any = useRef(null);
  useEffect(() => {
    const interval = setInterval(() => {
      // date
      var d = new Date();
      var dateOptions: object = {
        weekday: "short",
        month: "short",
        day: "numeric",
      };
      var date = d.toLocaleDateString(undefined, dateOptions);
      // time
      var hours = d.getHours();
      var ampm = hours >= 12 ? " PM" : " AM";
      hours = hours % 12;
      var time =
        ("0" + hours).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ampm;
      currentTime.current.innerHTML = date + " | " + time;
    }, 1000);
    return () => clearInterval(interval);
  }, [currentTime]);

  const [selectedLang, setSelectedLang] = useState<any>("");

  useEffect(() => {
    const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    const data = languages.find((item) => item.lang === currentLanguage);
    setSelectedLang(data);
  }, []);

  const changeLanguageAction = (lang: any) => {
    //set language as i18n
    i18n.changeLanguage(lang.lang);
    localStorage.setItem("I18N_LANGUAGE", lang.lang);
    setSelectedLang(lang);
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const { inherit } = Colortheme();

  const classes = useStyles();

  return (
    <React.Fragment>
      <TopTagBar
        sx={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          zIndex: "1250",
          backgroundColor: "#31404a",
          padding: "4px 20px",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>
            <IconText>
              <AccessTime
                sx={{
                  height: 16,
                  width: 15,
                  marginRight: "0.5rem",
                  color: "#ffffff80",
                }}
              />
              <span
                ref={currentTime}
                id="current-time"
                style={{ color: "#ffffff80" }}
              ></span>
            </IconText>
          </Box>
          <Box sx={{ display: { xs: "none", md: "none", lg: "flex" } }}>
            <EmailWebsiteDiv>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#ffffff80",
                }}
              >
                <MailOutline
                  sx={{
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                    color: "#ffffff80",
                    height: 15,
                    width: 13,
                  }}
                />
                support@themesbrand.com
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#ffffff80",
                }}
              >
                <Language
                  sx={{
                    verticalAlign: "middle",
                    marginRight: "0.5rem",
                    color: "#ffffff80",
                    height: 15,
                    width: 13,
                  }}
                />
                www.themesbrand.com
              </div>
            </EmailWebsiteDiv>
          </Box>
          {/* <Box sx={{ display: "flex", justifyContent: "flex-end", padding: '0' }}>
                        <LanguageDropdown sx={{ padding: '0' }} id="language-dropdown" aria-expanded="true" aria-controls="language-menu" aria-haspopup="true" onClick={handleClick}>
                            <Avatar alt="language_flag" src={selectedLang.flag} sx={{ width: 16, height: 16, marginRight: "10px" }} />
                            <Typography style={{ textTransform: "none", fontSize: "13px", color: '#ffffff80' }} >{selectedLang.label}</Typography>
                        </LanguageDropdown>
                        <Menu id="language-menu" anchorEl={anchorEl} className={classes.headerDropdown} open={Boolean(anchorEl)}
                            onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'right' }}>
                            {languages.map((item: any, key: number) => (
                                <StyledMenuItem onClick={() => changeLanguageAction(item)} key={key}>
                                    <img alt="rudrix" src={item.flag} width="16" height="16" />
                                    <Typography sx={{ fontSize: '14px', color: inherit }}>{item.label}</Typography>
                                </StyledMenuItem>
                            ))}
                        </Menu>
                    </Box> */}
        </Box>
      </TopTagBar>
    </React.Fragment>
  );
};

export default Topbar;
